import { lazy, Suspense, useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { defaultLanguage } from '@/i18n'
import { LanguageWrapper } from '@/components/LanguageRouter'
import { Layout } from '@/components/layout/Layout'

const HomePage = lazy(() => import('@/pages/HomePage'))
const AboutPage = lazy(() => import('@/pages/AboutPage'))
const ProcessesPage = lazy(() => import('@/pages/ProcessesPage'))
const InnovationPage = lazy(() => import('@/pages/InnovationPage'))
const ProductsPage = lazy(() => import('@/pages/ProductsPage'))
const SectorsPage = lazy(() => import('@/pages/SectorsPage'))
const SustainabilityPage = lazy(() => import('@/pages/SustainabilityPage'))
const ContactsPage = lazy(() => import('@/pages/ContactsPage'))
const PrivacyPage = lazy(() => import('@/pages/PrivacyPage'))
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'))

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-accent-600 border-t-transparent" />
    </div>
  )
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />

        <Route path="/:lang" element={<LanguageWrapper />}>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="processes" element={<ProcessesPage />} />
            <Route path="innovation" element={<InnovationPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="sectors" element={<SectorsPage />} />
            <Route path="quality" element={<Navigate to="../sustainability" replace />} />
            <Route path="sustainability" element={<SustainabilityPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to={`/${defaultLanguage}`} replace />} />
      </Routes>
    </Suspense>
  )
}
